export const fr = {
  commons: {
    accept: 'Accepter',
    cancel: 'Annuler',
    close: 'Fermer',
    delete: 'Supprimer',
    refuse: 'Refuser',
    search: 'Rechercher',
  },
  errors: {
    getKeyIndicators:
      'Une erreur est survenue lors de la récupération des informations. Veuillez réessayer ultérieurement',
  },
  dashboard: {
    title: 'Bienvenue sur mylight150 Pro',
    keyIndicators: {
      title: 'Vos indicateurs clés',
      lastUpdatedHours:
        "Dernière mise à jour : il y a moins d'une heure | Dernière mise à jour : il y a {count} heure | Dernière mise à jour : il y a {count} heures",
      lastUpdatedDays:
        'Dernière mise à jour : il y a 0 jour | Dernière mise à jour : il y a {count} jour | Dernière mise à jour : il y a {count} jours',
      totalInstallations: {
        title: 'Installation | Installation | Installations',
        description: "depuis le début de l'année",
        subText:
          'Total : {number} installation | Total : {number} installation | Total : {number} installations',
      },
      failingInstallations: {
        title: '%',
        description: "d'installations défaillantes",
        subText: 'Moyenne mylight150 : < {number}%',
      },
      activationRange: {
        title: 'Jour | Jour | Jours',
        description: "de délai médian d'activation",
        subText:
          'Moyenne mylight150 : < {number} jour | Moyenne mylight150 : < {number} jour | Moyenne mylight150 : < {number} jours',
      },
      equipmentsInstalled: {
        title: 'Equipement | Equipement | Equipements',
        description: 'installé en moyenne | installé en moyenne | installés en moyenne',
        subText: 'Moyenne mylight150 : > {number}',
      },
    },
    usefulLinks: {
      title: 'Ressources utiles',
      proSizer: 'MyProSizer',
      training: "S'inscrire à une formation",
      suggestEnhancement: 'Suggérer une amélioration',
      helpDesk: "Centre d'aide installateur",
    },
    explanationsModal: {
      subtitleOne: 'Pourquoi c’est important ?',
      subtitleTwo: 'Comment résoudre ?',
      failures: {
        title: 'Installations défaillantes',
        description:
          "Cet indicateur mesure la part de votre parc d'installations présentant des anomalies de mesure, de pilotage ou des pertes de communication.",
        paragraphOne:
          'Une installation défaillante empêche le client de suivre sa production en temps réel. Cela bloque le pilotage intelligent des équipements ainsi que la cagnotte et peut fausser la facturation de la batterie virtuelle, générant une insatisfaction.',
        paragraphTwo: `Dans l'onglet "Installation", vous pouvez filtrer sur les installations défaillantes. Puis sur chaque installation notée "défaillante", vous trouverez les anomalies constatées et un lien vers un article de FAQ qui explique comment les résoudre.`,
      },
      activationDeadline: {
        title: "Délai median d'activation",
        description:
          "Il s'agit du nombre de jours moyen entre la mise en service du matériel et la mise en service effective de la batterie virtuelle du client.",
        paragraphOne:
          "Tant que l'activation n'est pas finalisée, le client ne peut pas bénéficier de ses économies de batterie virtuelle. Un délai court renforce l'image de réactivité de votre entreprise et la satisfaction de vos clients.",
        paragraphTwo: `Anticipez la collecte des documents administratifs et assurez-vous de les transmettre au plus vite.`,
      },
      averageEquipmentsInstalled: {
        title: 'Equipements installés en moyenne',
        description:
          "Cet indicateur suit le nombre moyen d'appareils (chauffe-eau, bornes de recharge, pompes à chaleur) pilotés par MySmartPilot chez vos clients.",
        paragraphOne:
          "Plus il y a d'équipements connectés et pilotés, plus le client cagnotte sur son App. Cela justifie pleinement la valeur ajoutée de votre prestation technique et améliore la rentabilité de l'installation pour votre client.",
        paragraphTwo: `Lors de la phase de conseil, proposez systématiquement le raccordement des gros postes de consommation, proposez le coffret adapté à sa situation et vérifiez lors de l'installation que tous les relais de pilotage disponibles ont été configurés.`,
      },
    },
    stepByStep: {
      title: "Besoin d'aide ?",
      description:
        'Consulter notre guide interactif pour vous aider dans l’installation de votre matériel.',
      buttonLabel: "Découvrir le guide d'installation",
    },
  },
};
